var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMapTrifold = function SvgIconMapTrifold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.116 5.69 9.452 2.858a1 1 0 0 0-.7-.077L2.757 4.28A1 1 0 0 0 2 5.25v13.5a1 1 0 0 0 1.243.97l5.64-1.41 5.665 2.832a1 1 0 0 0 .7.077l5.995-1.499a1 1 0 0 0 .757-.97V5.25a1 1 0 0 0-1.242-.97zM16 7.53v11.44l4-1V6.53zm-8-2.5v11.44l-4 1V6.03zm2 .338v11.264l4 2V7.368z",
    clipRule: "evenodd"
  })));
};
export default SvgIconMapTrifold;